import React, { Suspense } from 'react';
import { Lazy } from '@root/src/web/components/Lazy';
import { isNPageOrHigherPageView, isValidContentType, isValidSection, isIOS9, isCountry, } from '@frontend/web/components/SignInGate/displayRule';
import { initPerf } from '@root/src/web/browser/initPerf';
import { hasUserDismissedGateMoreThanCount } from '../dismissGate';
const SignInGateMain = React.lazy(() => {
    const { start, end } = initPerf('SignInGateMainVar2');
    start();
    return import(
    /* webpackChunkName: "SignInGateMain" */ '../gateDesigns/SignInGateMainVar2').then((module) => {
        end();
        return { default: module.SignInGateMainVar2 };
    });
});
// 2nd page view & new dismiss rule (capped at 5)
const canShow = (CAPI, isSignedIn, currentTest) => !isSignedIn &&
    !hasUserDismissedGateMoreThanCount(currentTest.variant, currentTest.name, 5) &&
    isNPageOrHigherPageView(2) &&
    isValidContentType(CAPI) &&
    isValidSection(CAPI) &&
    !isIOS9() &&
    !isCountry('US');
export const signInGateComponent = {
    gate: ({ ophanComponentId, dismissGate, guUrl, signInUrl, abTest, isComment, }) => (React.createElement(Lazy, { margin: 300 },
        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
            React.createElement(SignInGateMain, { ophanComponentId: ophanComponentId, dismissGate: dismissGate, guUrl: guUrl, signInUrl: signInUrl, abTest: abTest, isComment: isComment })))),
    canShow,
};
